import React, { useId } from "react";
import PropTypes from "prop-types";

const CheckCalendarIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const clipId = `check-calendar-clip-${id}`;
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#666666";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M5.33301 1.33325V3.99992"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 1.33325V3.99992"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 9.33342V4.00008C14 3.26419 13.4026 2.66675 12.6667 2.66675H3.33333C2.59745 2.66675 2 3.26419 2 4.00008V13.3334C2 14.0693 2.59745 14.6667 3.33333 14.6667H8.66667"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 6.66675H14"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 13.3333L12.0003 14.6667L14.667 12"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

CheckCalendarIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

CheckCalendarIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default CheckCalendarIcon;
